import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "color-palette-generator",
  title: "Color Palette Generator",
  pageHeading: "Free Color Palette Generator",
  description:
    "Generate color palettes and color schemes, test harmonies and contrast, preview mockups, build gradients, recolor images, and export reusable colors.",
  seoTitle: "Free Color Palette Generator & Color Scheme Tool",
  seoDescription:
    "Generate color palettes and harmonious color schemes online. Lock and edit colors, check contrast, preview mockups, create gradients, and export your palette.",
  featureList: [
    "Color palette and harmony generation",
    "Lockable and editable color swatches",
    "Contrast comparison",
    "Palette undo and redo",
    "Mockup and gradient previews",
    "Image recoloring",
    "Palette favorites and exports",
  ],
  category: "Design",
} satisfies ToolMeta;
